// extracted by mini-css-extract-plugin
export var backdropBlur = "_66-0";
export var body = "_66-5";
export var bodyScroll = "_66-6";
export var columnFooter = "_66-7";
export var contentColumn = "_66-4";
export var frame = "_66-3";
export var heroContent = "_66-b";
export var heroOverlay = "_66-a";
export var image = "_66-9";
export var imageWrapper = "_66-8";
export var modal = "_66-1";
export var modalMain = "_66-2";
export var productHeader = "_66-c";
export var productHeaderIcon = "_66-d";
export var productHeaderName = "_66-e";
export var progressIndicator = "_66-f";